import React, { useRef, useState, useEffect } from "react";
import FullCalendar from "@fullcalendar/react";
import { daysBetween, formatDate } from "../../../../utils/commonFunctions";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import resourceTimelinePlugin from "@fullcalendar/resource-timeline";
import dayGridPlugin from "@fullcalendar/daygrid";
import { Link } from "react-router-dom";
import {
  CircularAvatar,
  EmptyListPage,
  TableLoader,
} from "../../../../components/commons";
import { ClientUserSchedulingListType } from "../../../../redux/scheduling/schedulingTypes";
import { ClientListType } from "../ClientVsUserScheduling/index";

type AppProps = {
  data: ClientUserSchedulingListType[] | [];
  fetching: boolean;
  totalCount?: number | null | undefined;
  startDate: string;
  endDate: string;
  displayStartDate: string;
  displayEndDate: string;
  clientSelected: ClientListType;
};
const ClientUserScheduleCalendarView = ({
  data,
  fetching,
  totalCount,
  startDate,
  endDate,
  displayStartDate,
  displayEndDate,
  clientSelected,
}: AppProps) => {
  const calendarRef = useRef<any>(null);
  const [resources, setResources] = useState<any>([]); //left calander
  const [selectedEvent, setSelectedEvent] = useState<any>(null);
  const [mode, setMode] = useState("AllWeek");
  const [currentData, setCurrentData] = useState<any>([]);
  const [calendarHeaderSum, setCalendarHeaderSum] = useState<any>([]);
  const [calenderDate, setCalenderDate] = useState("2023-08-01");
  const [finalcalendarData, setFinalcalendarData] = useState<any>([]);

  useEffect(() => {
    setFinalcalendarData([]);
    if (data?.length) {
      const finalResources = data?.map((el: any, index: number) => {
        const totalHours = el?.estimate?.reduce(
          (accumulator: any, currentValue: any) =>
            accumulator + (currentValue?.hours ? +currentValue?.hours : 0),
          0
        );
        return {
          id: index + 1,
          name: el?.user_name,
          profilePic: el?.profile_pic?.file_url,
          department: el?.department,
          userId: el?.user_id,
          hours: totalHours?.toString()?.includes(".")
            ? +totalHours?.toFixed(2)
            : totalHours
            ? +totalHours
            : 0,
          jobTitle: el?.job_title,
        };
      });
      setResources([
        {
          id: 0,
          name: "TOTAL HOURS",
        },
        ...finalResources,
      ]);
    }
  }, [data]);

  useEffect(() => {
    if (data?.length > 0) {
      let events = data
        ?.map((e: any, index: number) => {
          return e?.estimate?.map((el: any, i: number) => {
            return {
              resourceId: index + 1,
              campaignId: index + 1,
              name: el?.hours?.toString()?.includes(".")
                ? +(+el?.hours)?.toFixed(2)
                : el?.hours
                ? +el?.hours
                : 0,
              start: new Date(el?.date),
              end: new Date(el?.date),
              allDay: true,
            };
          });
        })
        .flat();
      setCurrentData([...events]);
    }
    //
    else {
      setCurrentData([]);
    }
  }, [data]);

  useEffect(() => {
    let arr: any = [];
    if (currentData?.length) {
      currentData?.forEach((el: any) => {
        let date = new Date(el?.start);
        let JsonDate = JSON.stringify(date);
        let final = JsonDate.slice(1, 11);
        arr.push({ date: final, hours: el?.name });
      });

      arr.sort((a: any, b: any) => {
        if (a?.date !== b?.date) {
          return a?.date.localeCompare(b?.date);
        }
        return a?.hours - b?.hours;
      });
      ///sum of header sum
      const dateHoursMap: any = {};
      arr?.forEach((entry: any) => {
        const date = entry?.date;
        const hours = entry?.hours?.toString()?.includes(".")
          ? (+entry?.hours)?.toFixed(2)
          : entry?.hours
          ? +entry?.hours
          : 0;
        if (date in dateHoursMap) {
          dateHoursMap[date] += +hours;
        } else {
          dateHoursMap[date] = +hours;
        }
      });
      const result = Object?.entries(dateHoursMap)?.map(([date, hours]) => ({
        resourceId: 0,
        campaignId: 0,
        name: hours?.toString()?.includes(".")
          ? (+hours)?.toFixed(2)
          : hours
          ? +hours
          : 0,
        start: new Date(date),
        end: new Date(date),
        allDay: true,
      }));
      setFinalcalendarData([...result, ...currentData]);
    }
    //
    else {
      setFinalcalendarData([]);
    }
  }, [currentData]);

  const handleEventResize = (info: any) => {
    const target = info.jsEvent.target;
    if (
      target.classList.contains("fc-resource-timeline-divider") ||
      target.classList.contains("fc-cell-shaded")
    ) {
      info.revert(); // Revert the resize
    }
  };

  const handleSetLocalStorageData = (userId: number, name: string) => {
    localStorage.setItem("user_id", userId?.toString());
    localStorage.setItem("isRedirected", "employeeSchedule");
    localStorage.setItem("name", name);
    localStorage.setItem("start_date", displayStartDate);
    localStorage.setItem("end_date", displayEndDate);
  };

  const CampaignResource = ({ resource }: any) => {
    const {
      name,
      from,
      to,
      type,
      hours,
      profilePic,
      department,
      jobTitle,
      userId,
    } = resource.extendedProps;
    let finalName = name?.slice(0, 20) + "";
    return (
      <>
        <td
          className="job-id"
          style={{
            color: "#262a44",
            fontSize: "14px",
            fontWeight: "500",
            border: "none",
            borderBottom: resource?.length == 1 ? "1px solid black" : "",
            background: name == "TOTAL HOURS" ? "#e8ecf0" : "white",
            width: "300px",
            wordWrap: "break-word",
          }}
        >
          <div className="ml-2" style={{ width: "100%" }}>
            {name !== "TOTAL HOURS" && (
              <div className="d-flex">
                <CircularAvatar name={name} image={profilePic} />
                <div className="ml-2">
                  {name?.length > 20 ? (
                    <OverlayTrigger
                      placement="top"
                      delay={{ show: 250, hide: 250 }}
                      overlay={
                        <Tooltip id="button-view-open-item">{name}</Tooltip>
                      }
                    >
                      <Link
                        target="_blank"
                        to={`/scheduling/user`}
                        onClick={() =>
                          handleSetLocalStorageData(userId, finalName)
                        }
                        style={{
                          textDecoration: "underline",
                          color: "#262a44",
                          fontWeight: "500",
                          textUnderlineOffset: "3px",
                          cursor: "pointer",
                          marginBottom: 0,
                        }}
                      >
                        {finalName}
                      </Link>
                    </OverlayTrigger>
                  ) : (
                    <Link
                      target="_blank"
                      to={`/scheduling/user`}
                      onClick={() =>
                        handleSetLocalStorageData(userId, finalName)
                      }
                      style={{
                        textDecoration: "underline",
                        color: "#262a44",
                        fontWeight: "500",
                        textUnderlineOffset: "3px",
                        cursor: "pointer",
                        marginBottom: 0,
                      }}
                    >
                      {name}
                    </Link>
                  )}
                  {jobTitle?.length > 20 ? (
                    <OverlayTrigger
                      placement="top"
                      delay={{ show: 250, hide: 250 }}
                      overlay={
                        <Tooltip id="button-view-open-item">
                          <div className="d-flex flex-column">
                            {!!jobTitle?.length && (
                              <span>Job Title : {jobTitle}</span>
                            )}
                            {!!department?.length && (
                              <span>Department : {department}</span>
                            )}
                          </div>
                        </Tooltip>
                      }
                    >
                      <div style={{ fontSize: "12px", color: "#6e7491" }}>
                        {jobTitle?.slice(0, 20) + "...."}
                      </div>
                    </OverlayTrigger>
                  ) : (
                    <span style={{ fontSize: "12px", color: "#6e7491" }}>
                      <OverlayTrigger
                        placement="top"
                        delay={{ show: 250, hide: 250 }}
                        overlay={
                          <Tooltip id="button-view-open-item">
                            <div className="d-flex flex-column">
                              {!!jobTitle?.length && (
                                <span>Job Title : {jobTitle}</span>
                              )}
                              {!!department?.length && (
                                <span>Department : {department}</span>
                              )}
                            </div>
                          </Tooltip>
                        }
                      >
                        <div style={{ fontSize: "12px", color: "#6e7491" }}>
                          {jobTitle}
                        </div>
                      </OverlayTrigger>
                    </span>
                  )}
                </div>
              </div>
            )}
          </div>
        </td>
        <td
          className="job-id"
          style={{
            color: hours === "&" ? "transparent" : "#262a44",
            fontSize: "14px",
            fontWeight: "500",
            borderTop: "none",
            borderRight: "none",
            background: name === "TOTAL HOURS" ? "#e8ecf0" : "white",
          }}
        >
          {name === "TOTAL HOURS" ? (
            <div
              style={{ fontWeight: "600", color: "#464f60", fontSize: "12px" }}
            >
              TOTAL HOURS
            </div>
          ) : (
            hours
          )}
        </td>
      </>
    );
  };

  const resourceAreaHeaderContent = (arg: any) => {
    return (
      <div
        style={{
          textAlign: "initial",
          fontSize: "12px",
          marginTop: "21px",
          color: "#464f60",
        }}
        className="ml-4"
      >
        EMPLOYEE NAME
      </div>
    );
  };

  const computeDurations = (mode: any) => {
    const durationDays = daysBetween(displayStartDate, displayEndDate) + 1;
    if (startDate && endDate) {
      switch (mode) {
        case "AllWeek":
          let finalResult: any = {
            slotDuration: { days: 1 },
            slotLabelFormat: [{ month: "long" }, { day: "2-digit" }],
            duration: { days: durationDays },
          };
          return finalResult;

        default:
          return {};
      }
    } else {
      return {
        slotDuration: { days: 1 },
        slotLabelFormat: [{ month: "long" }, { day: "2-digit" }],
        duration: { days: durationDays },
      };
    }
  };

  //total hours header

  const { duration, slotDuration, slotLabelFormat } = computeDurations(mode);

  const handleEventContent = (eventInfo: any) => {
    if (
      selectedEvent &&
      selectedEvent?._def?.extendedProps?.campaignId ===
        eventInfo?.event?._def?.extendedProps?.campaignId
    ) {
      return <div></div>;
    } else if (eventInfo?.event?._def?.extendedProps?.name != 0) {
      let checkId = eventInfo?.event?._def?.extendedProps?.campaignId;
      let checkName = eventInfo?.event?._def?.extendedProps?.name;
      return (
        <>
          <div
            style={{
              height: "61.5px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              fontSize: "15px",
              fontWeight: 500,
              width: "100%",
              margin: "auto",
            }}
          >
            <span
              style={{
                width: checkId != 0 ? "100%" : checkId === 0 ? "50%" : "100%",
                height: checkId === 0 && checkName > 12 ? "30px" : "61.5px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background:
                  checkId === 0 && checkName >= 12
                    ? ""
                    : checkId === 0 && checkName <= 12
                    ? ""
                    : checkName < 12
                    ? "#e7f0d4"
                    : "#faedd8",

                color:
                  checkId === 0 && checkName >= 12
                    ? ""
                    : checkId === 0 && checkName <= 12
                    ? ""
                    : checkName >= 12
                    ? "#ac6602"
                    : "#5a7d0e",
              }}
            >
              {" "}
              {checkName}
            </span>
            <span></span>
          </div>
        </>
      );
    } else {
      return <div></div>;
    }
  };
  let adjustedEndDate = new Date(displayEndDate);
  adjustedEndDate.setDate(adjustedEndDate.getDate() + 1);
  return (
    <>
      <div className="all-users" style={{ marginTop: "7px" }}>
        {fetching ? (
          <TableLoader Rows={7} ColumnPerRow={7} />
        ) : finalcalendarData?.length == 0 ? (
          <div className="mt-5">
            <EmptyListPage title="No Schedules Found!" imageWidth="30%" />{" "}
          </div>
        ) : (
          <>
            {resources?.length ? (
              <FullCalendar
                ref={calendarRef}
                plugins={[resourceTimelinePlugin, dayGridPlugin]}
                initialView={"resourceTimeline"}
                initialDate={startDate}
                validRange={{
                  start: displayStartDate,
                  end: adjustedEndDate,
                }}
                weekends={true}
                resourceAreaWidth="30%"
                resourceOrder="from"
                headerToolbar={{
                  left: "",
                  center: "title",
                  right: "",
                }}
                height={"90vh"}
                eventContent={handleEventContent}
                eventResize={handleEventResize} // Handle event resize
                resourceAreaHeaderContent={resourceAreaHeaderContent}
                slotDuration={slotDuration}
                slotLabelFormat={slotLabelFormat}
                duration={duration}
                resourceLabelContent={CampaignResource}
                resources={resources}
                slotMinWidth={60}
                views={{
                  resourceTimelineDay: {
                    slowMinWidth: 50,
                  },
                }}
                eventClick={(arg: any) => arg.jsEvent.preventDefault()} // Prevent default eventClick behavior
                events={finalcalendarData} //box events
              />
            ) : (
              <>
                {totalCount == 0 ? (
                  <div className="mt-5">
                    <EmptyListPage
                      title="No Schedules Found!"
                      imageWidth="30%"
                    />
                  </div>
                ) : (
                  <TableLoader Rows={7} ColumnPerRow={8} />
                )}
              </>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default ClientUserScheduleCalendarView;
